export const geoApiOptions = {
    method: "GET",
    params: {limit: '10'},
    headers: {
      "X-RapidAPI-Key": "f1c9e3cd17msh7fb2056c3b56474p1b759ajsn318ba4672efb",
      "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
    },
  };
  export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo/cities";
  
  export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
  export const WEATHER_API_KEY = "9ceca9b6c8b3dd41a719ec502cfb1fcb";